import React from 'react';
import Box from '@mui/material/Box';
import { alpha } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import Badge from '@mui/material/Badge';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Popover from '@mui/material/Popover';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import InboxIcon from '@mui/icons-material/Inbox';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MailIcon from '@mui/icons-material/Mail';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MoreIcon from '@mui/icons-material/MoreVert';
import httpRequest from './HttpService';
import Link from '@mui/material/Link';
import { palette } from './palette';
import Grid from '@mui/material/Grid';
import { useLocation } from 'react-router-dom';
import { SvgIcon } from '@mui/material';
import logo from './logo.svg';
import 'animate.css/animate.css';
import {NavLink} from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const MNavLink = ({ selected, sx, ...rest }) => (
    <Link
        {...rest}
        sx={{
            color: selected ? 'black' : 'grey',
            textDecoration: 'none',
            '&:hover': { color: 'black', textDecoration: 'none' },
            ...sx,
        }}
    />
);

const sxGrow = { flexGrow: 1 };
const sxLogoButton = { mr: 2 };
const sxSectionDesktop = { display: { xs: 'none', md: 'flex' }, alignItems: { md: 'center' } };
const sxSectionMobile = { display: { xs: 'flex', md: 'none' } };
const sxAccountLabel = {
    color: 'white',
    fontSize: '0.85rem',
    fontWeight: 500,
    mr: 1,
    opacity: 0.85,
    whiteSpace: 'nowrap',
};
const sxAccountSelect = {
    minWidth: 180,
    maxWidth: 260,
    mr: 1,
    backgroundColor: 'rgba(255,255,255,0.12)',
    borderRadius: 1,
    '&:hover': { backgroundColor: 'rgba(255,255,255,0.2)' },
    '& .MuiNativeSelect-select, & .MuiSelect-select': {
        color: 'white',
        padding: '6px 28px 6px 10px',
        fontSize: '0.9rem',
    },
    '& .MuiNativeSelect-icon, & .MuiSelect-icon': { color: 'white' },
    '& .MuiInput-underline:before, & .MuiInput-underline:after, & .MuiInput-underline:hover:not(.Mui-disabled):before': {
        borderBottom: 'none',
    },
};

export default function NavigationBar(props) {
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
    const [drawerOpen, setDrawerOpen] = React.useState(false);
    const [historyAnchorEl, setHistoryAnchorEl] = React.useState(null);
    const [notificationHistory, setNotificationHistory] = React.useState([]);
    const isMenuOpen = Boolean(anchorEl);
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
    const isHistoryOpen = Boolean(historyAnchorEl);

    const handleHistoryOpen = (event) => {
        setHistoryAnchorEl(event.currentTarget);
        httpRequest.getNotificationHistory()
            .then((response) => {
                setNotificationHistory(response.data || []);
            })
            .catch(() => {
                setNotificationHistory([]);
            });
    };

    const handleHistoryClose = () => {
        setHistoryAnchorEl(null);
    };

    const handleProfileMenuOpen = (event) => {
        console.log("handleProfileMenuOpen");
        setAnchorEl(event.currentTarget);
       // window.location.href='/preferences';    
        navigate('/preferences');

    };

    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        handleMobileMenuClose();
    };

    const handleMobileMenuOpen = (event) => {
        setMobileMoreAnchorEl(event.currentTarget);
    };

    const handleAccountChange = (event) => {
        const newAccount = event.target.value;
        if (!newAccount || newAccount === props.account) return;
        localStorage.setItem('accountNumber', newAccount);
        if (props.updateGlobalAccount) {
            props.updateGlobalAccount(newAccount);
        }
    };

    const accountList = props.accountList || [];
    const showAccountSelector = props.isLoggedIn && accountList.length > 0 && props.account;

    const pathname = useLocation().pathname;
    console.log("NavigationBar", pathname);
    if(!pathname.includes("orderDetail") && !pathname.includes("history"))
        localStorage.setItem('searchHistory', 'no'); 


    const menuId = 'primary-search-account-menu';
    const mobileMenuId = 'primary-search-account-menu-mobile';
    const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
        {showAccountSelector && (
            <MenuItem disableGutters style={{ padding: '8px 16px', gap: '8px' }}>
                <Typography variant="body2" style={{ fontWeight: 500, color: 'grey' }}>
                    Account
                </Typography>
                <FormControl size="small" fullWidth>
                    <Select
                        value={props.account}
                        onChange={(e) => { handleAccountChange(e); handleMobileMenuClose(); }}
                        native
                        inputProps={{ 'aria-label': 'Select account' }}
                    >
                        {accountList.map((acct) => (
                            <option key={acct.value} value={acct.value}>
                                {acct.label}
                            </option>
                        ))}
                    </Select>
                </FormControl>
            </MenuItem>
        )}
        {props.isLoggedIn && <MenuItem>
            <MNavLink href="/neworder" selected={pathname === '/neworder'}>
                New Order
            </MNavLink>
        </MenuItem>}
        {props.isLoggedIn && <MenuItem>
            <MNavLink href="/orderstatus" selected={pathname === '/orderstatus'}>
                Order Status
            </MNavLink>
        </MenuItem>}       
        {props.isLoggedIn && <MenuItem>
            <MNavLink href="/faq" color="inherit" selected={pathname === '/faq'}>
                FAQ & More
            </MNavLink>
        </MenuItem>}
        {!props.isLoggedIn && <MenuItem>
            <MNavLink href="/" selected={pathname === '/'}>
                Generate Token
            </MNavLink>
        </MenuItem>}        
        {!props.isLoggedIn && <MenuItem>
            <MNavLink href="/tracking" selected={pathname === '/tracking'}>
               Tracking
            </MNavLink>
        </MenuItem>} 
      
    </Menu>
  );

  return (
    <Box sx={sxGrow}>
        <AppBar position="sticky" style={{background: palette.greys.dark}}>
            <Toolbar>
                <IconButton
                edge="start"
                sx={sxLogoButton}
                color="inherit"
                href="/#"
                >
                    <img src={logo} alt="Direct IT"/>
                </IconButton>
                <Grid>

                </Grid>
                {props.isLoggedIn &&
                <Box sx={sxSectionDesktop}>
                    {/* <NavLink href="/neworder" selected={pathname === '/neworder'}> */}
                    <NavLink to="/neworder" selected={pathname === '/neworder'}>
                        New Order
                    </NavLink>
                    <p>&emsp;</p>
                    {/* <NavLink href="/orderstatus" selected={pathname === '/orderstatus'}> */}
                    <NavLink to="/orderstatus" selected={pathname === '/orderstatus'}>
                        Order Status
                    </NavLink>
                    <p>&emsp;</p>  
                    <NavLink to="/history" selected={pathname === '/history'}>
                        History
                    </NavLink>
                    <p>&emsp;</p>
                    <NavLink to="/invoices" selected={pathname === '/invoices'}>
                        Invoices
                    </NavLink>
                    <p>&emsp;</p>                  
                    {/* <NavLink href="/faq" color="inherit" selected={pathname === '/faq'}> */}
                    <NavLink to="/faq" selected={pathname === '/faq'}>
                        FAQ & More
                    </NavLink>
                </Box>}

                {!props.isLoggedIn &&
                <Box sx={sxSectionDesktop}>
                    {/* <NavLink href="/" selected={pathname === '/'}> */}
                    <NavLink to="/" selected={pathname === '/'}>
                        Generate Token
                    </NavLink>
                    <p>&emsp;</p>
                    {/* <NavLink href="/tracking" selected={pathname === '/tracking'}> */}
                    <NavLink to="/tracking" selected={pathname === '/tracking'}>
                        Tracking
                    </NavLink>
                </Box>}

                <Box sx={sxGrow} />
                {props.isLoggedIn &&
                <Box sx={sxSectionDesktop}>
                {showAccountSelector && (
                    <>
                        <Typography sx={sxAccountLabel} component="span">
                            Account
                        </Typography>
                        <FormControl sx={sxAccountSelect} size="small" variant="standard">
                            <Select
                                value={props.account}
                                onChange={handleAccountChange}
                                disableUnderline
                                native
                                variant="standard"
                                inputProps={{ 'aria-label': 'Select account' }}
                            >
                                {accountList.map((acct) => (
                                    <option key={acct.value} value={acct.value} style={{ color: 'black' }}>
                                        {acct.label}
                                    </option>
                                ))}
                            </Select>
                        </FormControl>
                    </>
                )}
                <IconButton
                aria-label="notification history"
                onClick={handleHistoryOpen}
                color="inherit"
                >
                <NotificationsIcon />
                </IconButton>
                <Popover
                    open={isHistoryOpen}
                    anchorEl={historyAnchorEl}
                    onClose={handleHistoryClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                    <div style={{ width: 320, maxHeight: 400, overflowY: 'auto' }}>
                        <Typography variant="subtitle2" style={{ padding: '8px 16px', fontWeight: 600 }}>
                            Notification History
                        </Typography>
                        <Divider />
                        {notificationHistory.length === 0 ? (
                            <Typography variant="body2" style={{ padding: '12px 16px', color: 'grey' }}>
                                No notification history.
                            </Typography>
                        ) : (
                            <List dense disablePadding>
                                {notificationHistory.map((n, i) => (
                                    <React.Fragment key={n.notificationID || i}>
                                        <ListItem alignItems="flex-start">
                                            <ListItemText
                                                primary={n.noteText}
                                                secondary={n.acknowledgedDate || null}
                                            />
                                        </ListItem>
                                        {i < notificationHistory.length - 1 && <Divider component="li" />}
                                    </React.Fragment>
                                ))}
                            </List>
                        )}
                    </div>
                </Popover>
                <IconButton
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                color="inherit"
                >
                <AccountCircle />
                </IconButton>
            </Box>}

            <Box sx={sxSectionMobile}>
                {props.isLoggedIn &&
                <IconButton
                aria-label="notification history"
                onClick={handleHistoryOpen}
                color="inherit"
                >
                <NotificationsIcon />
                </IconButton>}
                <IconButton
                aria-label="show more"
                aria-controls={mobileMenuId}
                aria-haspopup="true"
                onClick={handleMobileMenuOpen}
                color="inherit"
                >
                <MoreIcon />
                </IconButton>
            </Box>
            </Toolbar>
        </AppBar>
        {renderMobileMenu}
    </Box>
  );
}
